// Manager-facing account settings — GET/PATCH /api/manager/settings.
// Currently a single field: notification channel. `auto` is today's
// org-only routing (workspace DM if the org has Slack/Google Workspace
// connected, else email); `email` forces direct email regardless of org
// integration state. No `workspace`-forced option — that would silently
// blackhole notifications for an org with no integration connected.

import { z } from 'zod';

export const MANAGER_NOTIFICATION_CHANNELS = ['auto', 'email'] as const;
export type ManagerNotificationChannel = (typeof MANAGER_NOTIFICATION_CHANNELS)[number];

export const SetManagerNotificationChannelRequestSchema = z
  .object({
    notificationChannel: z.enum(MANAGER_NOTIFICATION_CHANNELS),
  })
  .strict();
export type SetManagerNotificationChannelRequest = z.infer<
  typeof SetManagerNotificationChannelRequestSchema
>;

export interface ManagerSettingsResponse {
  notificationChannel: ManagerNotificationChannel;
}
